module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-data-table', {
    ref: "sortableTable",
    staticClass: "elevation-1",
    attrs: {
      "loading": "true",
      "headers": _vm.headers,
      "items": _vm.quoteApis,
      "search": _vm.search,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "sortableRow",
          attrs: {
            "id": "rows"
          }
        }, [_c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_vm._v(_vm._s(props.item.type))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_vm._v(_vm._s(props.item.api_name))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_vm._v(_vm._s(props.item.datetime))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "70%"
          }
        }, [_c('code', {
          staticStyle: {
            "padding": "24px"
          }
        }, [_vm._v(_vm._s(props.item.api_data))])])])]
      }
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-1 pb-2 pt-2 buttonHolder",
    staticStyle: {
      "margin-top": "0px !important"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1)])], 1)], 1)
},staticRenderFns: []}